module.exports = __webpack_public_path__ + "static/media/meta.5c006d33.webp";